import { ref, readonly } from 'vue'

type ToastType = 'success' | 'error' | 'info' | 'warning'

// By defining the state outside the function, we create a single, shared instance (a singleton).
// This ensures that any component calling useToast() will interact with the same state.
const isVisible = ref(false)
const type = ref<ToastType>('info')
const title = ref('')
const message = ref('')
const duration = ref(3000)

export function useToast() {
  const showToast = (toastOptions: {
    type: ToastType,
    title: string,
    message?: string,
    duration?: number
  }) => {
    type.value = toastOptions.type
    title.value = toastOptions.title
    message.value = toastOptions.message || ''
    duration.value = toastOptions.duration || 3000
    isVisible.value = true
  }

  const hideToast = () => {
    isVisible.value = false
  }

  return {
    isVisible: readonly(isVisible),
    type: readonly(type),
    title: readonly(title),
    message: readonly(message),
    duration: readonly(duration),
    showToast,
    hideToast,
  }
} 